import {
  error,
  IList,
  pending,
  promiseState,
  success
} from 'annotation-tools/utils';
import { from, Observable } from 'rxjs';
import { map, mergeMap, scan, startWith, switchMap } from 'rxjs/operators';
import { FetchErrorType } from '../../../../api/types/common/fetch-error-type';
import { FetchResultType } from '../../../../api/types/common/fetch-result';
import {
  ListWithPromiseState,
  listWithPromiseStateInit
} from '../list-with-status';

export const attachPromiseStateToList = (
  method: 'switchMap' | 'mergeMap' = 'switchMap'
) => <T>(
  fetchListPromise$: Observable<
    Promise<FetchResultType<IList<T>, FetchErrorType<void>>>
  >
): Observable<ListWithPromiseState<T>> =>
  fetchListPromise$.pipe(
    (method === 'switchMap' ? switchMap : mergeMap)(fetchPromise =>
      from(fetchPromise).pipe(
        map(result => ({ op: 'settled' as const, result })),
        startWith({ op: 'pending' as const })
      )
    ),
    scan((state, action) => {
      switch (action.op) {
        case 'pending':
          return pending(state.value);

        case 'settled': {
          switch (action.result.type) {
            case promiseState.success:
              return success({ latest: action.result.body });

            case promiseState.error:
              return error({
                latest: state.value.latest,
                reason: {
                  statusCode: action.result.statusCode,
                  headers: action.result.headers,
                  errorBody: action.result.body
                }
              });
          }
        }
      }
    }, listWithPromiseStateInit<T>()),
    startWith(listWithPromiseStateInit<T>())
  );
